import {
  type TableOnCellClick,
  type TablePaginationProps,
  type TableSetRowHref,
  type TableSortProps,
  Table,
} from 'libs/ui';

import { OperationsListItem, SortField } from '../../types';

import { useColumns } from './columns';

export interface OperationsTableProps
  extends TablePaginationProps,
    TableSortProps<SortField> {
  operations: OperationsListItem[];
  loading?: boolean;
  brokerTimezoneOffset: number;
  onCellClick?: TableOnCellClick<OperationsListItem>;
  setRowHref?: TableSetRowHref<OperationsListItem>;
  noRowsLabel?: string;
}

export const OperationsTable = ({
  loading,
  limit,
  page,
  rowCount,
  operations,
  brokerTimezoneOffset,
  sort,
  setRowHref,
  onCellClick,
  onPaginationChange,
  onSortChange,
  noRowsLabel,
}: OperationsTableProps) => {
  const columns = useColumns({ brokerTimezoneOffset });

  return (
    <Table
      columns={columns}
      limit={limit}
      loading={loading}
      noRowsLabel={noRowsLabel}
      page={page}
      rowCount={rowCount}
      rowHeight={60}
      rows={operations}
      setRowHref={setRowHref}
      sort={sort}
      onCellClick={onCellClick}
      onPaginationChange={onPaginationChange}
      onSortChange={onSortChange}
    />
  );
};
